import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Custom hook to track page views on route changes for Single Page Application (SPA)
 * 
 * CRITICAL: This ensures GA4 "Pages & Screens" report populates correctly
 * Without this, GA4 only records the initial page load
 * 
 * Usage: Add `usePageTracking()` to App.js
 */
export const usePageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    // Get page title from document
    const pageTitle = document.title || 'Ophilia';
    
    // Get full path with search params
    const pagePath = location.pathname + location.search;

    // Track page view in GA4
    trackPageView(pagePath, pageTitle);
  }, [location]);
};

export default usePageTracking;
